import React from "react";
import Modal from "../../../components/Modal/Modal";
import { TitleModalFilter } from "../style";
import styled from "styled-components";
import { MyButton } from "../../../components/Button/style";
import metamaskIcon from "../../../assets/images/metamask.png";
import { useApp } from "../../../contexts";
import { Copy } from "../../../components/Copy";
import { Button, Space } from "antd";
import { splitAddressWallet } from "../../../utils/hepler";
import { useWindowSize } from "../../../hook/useWindowSize";
import { deviceDetect } from "react-device-detect";

const ModalContainer = styled(Modal.Container)`
  padding: 48px 64px;
  width: 425px;
  height: 366px;
  background: #f5f5f5;
  &.connected {
    width: 537px;
    height: 366px;
    padding: 48px 80px 57px 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: 1024px) {
      width: 375px;
      height: 376px;
      padding: 32px;
    }
  }
  @media (max-width: 640px) {
    width: 335px;
    height: 330px;
    padding: 32px;
  }
`;

const ModalTitle = styled(TitleModalFilter)`
  color: #000;
  @media (max-width: 1024px) {
    font-size: 22px;
  }
  &.connected {
    color: #F12E11;
  }
`;

const ButtonConnect = styled(Button)`
  width: 298px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 400;
  font-size: 16px;
  line-height: 17px;
  text-align: center;
  color: #000000;
  border: none;
  background: #ffffff;
  border-radius: 10px;
  @media (max-width: 1024px) {
    width: 270px;
  }
  img {
    display: inline-block;
    width: 24px;
    height: 24px;
  }
`;

const TextTypeWallet = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #4f4f4f;
  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #4f4f4f;
  }
`;

const TextAddressWallet = styled.span`
  margin-top: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
  color: #4f4f4f;
  @media (max-width: 1024px) {
    margin-top: 6px;
    font-weight: 500;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    color: #4f4f4f;
  }
`;

const TextLinkAddress = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4f4f4f;
  @media (max-width: 768px) {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #4f4f4f;
  }
`;

const CustomIconCopy = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6667 7.89844H9.16667C8.24619 7.89844 7.5 8.64463 7.5 9.5651V17.0651C7.5 17.9856 8.24619 18.7318 9.16667 18.7318H16.6667C17.5871 18.7318 18.3333 17.9856 18.3333 17.0651V9.5651C18.3333 8.64463 17.5871 7.89844 16.6667 7.89844Z"
      stroke="#4F4F4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16675 12.8983H3.33341C2.89139 12.8983 2.46746 12.7227 2.1549 12.4101C1.84234 12.0976 1.66675 11.6736 1.66675 11.2316V3.73161C1.66675 3.28958 1.84234 2.86566 2.1549 2.5531C2.46746 2.24054 2.89139 2.06494 3.33341 2.06494H10.8334C11.2754 2.06494 11.6994 2.24054 12.0119 2.5531C12.3245 2.86566 12.5001 3.28958 12.5001 3.73161V4.56494"
      stroke="#4F4F4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconLinkAddress = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 10.8333V15.8333C15 16.2754 14.8244 16.6993 14.5118 17.0118C14.1993 17.3244 13.7754 17.5 13.3333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V6.66667C2.5 6.22464 2.67559 5.80072 2.98816 5.48816C3.30072 5.17559 3.72464 5 4.16667 5H9.16667"
      stroke="#4F4F4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 2.5H17.5V7.5"
      stroke="#4F4F4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33325 11.6667L17.4999 2.5"
      stroke="#4F4F4F"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ModalConnectWallet = ({ onClose }) => {
  const size = useWindowSize();
  const { isBrowser } = deviceDetect();
  const {
    addressConnected,
    disconnectWallet,
    changeWallet,
    T,
    connectAddress,
    user,
    setAlert,
  } = useApp();
  const isSameConnectedAccount = (() => {
    try {
      if (typeof window === "undefined") return false;
      if (!window.ethereum || !addressConnected) return false;
      const currentAddress = window.ethereum.selectedAddress;
      if (!currentAddress) return false;
      return currentAddress.toLowerCase() === addressConnected.toLowerCase();
    } catch (e) {
      return false;
    }
  })();
  const handleConnect = async () => {
    try {
      await window.ethereum
        .request({ method: "eth_requestAccounts" })
        .then((res) => {
          if (res?.length) {
            connectAddress(res[0]);
            onClose?.();
          }
        });
    } catch (error) {
      console.log(error);
      if (!isBrowser) {
        document.querySelector("#metamask-link").click();
        return;
      }
      setAlert({
        type: "error",
        text: T("please install MetaMask extension."),
      });
    }
  };
  return (
    <Modal>
      <Modal.ModalBg onClick={onClose} />
      <ModalContainer
        className={addressConnected ? "connected" : ""}
        onClose={onClose}
      >
        {addressConnected ? (
          <>
            <ModalTitle className={addressConnected ? "connected" : ""}>
              {T("title.account")}
            </ModalTitle>
            <div className="mt-[15px] sm:mt-[30px] flex flex-col w-full">
              <TextTypeWallet>
                {T("Connected with Metamask Wallet")}
              </TextTypeWallet>
              <TextAddressWallet>
                {splitAddressWallet(addressConnected)}
              </TextAddressWallet>
              <div className="flex justify-around mt-[24px]">
                <Space>
                  <Copy
                    icon={CustomIconCopy}
                    isShowText={false}
                    textStyle={{ fontWeight: 400, fontSize: 15 }}
                    text={addressConnected}
                  />
                  <TextLinkAddress>{T("title.copyAddress")}</TextLinkAddress>
                </Space>
                <Space>
                  <a
                    target="_blank"
                    href={`https://etherscan.io/address/${addressConnected}`}
                    rel="noreferrer"
                  >
                    {IconLinkAddress}
                  </a>
                  <TextLinkAddress>{T("View on Etherscan")}</TextLinkAddress>
                </Space>
              </div>

              <Space
                size={15}
                direction={size.width > 1024 ? "horizontal" : "vertical"}
                className="mt-[32px] sm:mt-[40px] justify-center"
                align="center"
              >
                <MyButton
                  style={size.width > 1024 ? {} : { width: "100%" }}
                  onClick={() => disconnectWallet(() => {
                    onClose?.();
                  })}
                >
                  {T("title.disconnect")}
                </MyButton>
                {!isSameConnectedAccount && (
                  <MyButton
                    style={size.width > 1024 ? {} : { width: "100%" }}
                    className="primary"
                    onClick={() => changeWallet(() => {
                      onClose?.();
                    })}
                  >
                    {T("title.change")}
                  </MyButton>
                )}
              </Space>
            </div>
          </>
        ) : (
          <>
            <ModalTitle>{T("title.selectWallet")}</ModalTitle>
            <div className="mt-[35px] flex flex-col gap-[20px] justify-center">
              <a
                hidden
                id="metamask-link"
                href={`${process.env.REACT_APP_DEEP_LINK_METAMASK}?token=${user?.token}`}
              >
                MetaMask
              </a>
              <ButtonConnect className="mt-[52px]" onClick={handleConnect}>
                <img src={metamaskIcon} alt="" />
                {T("Metamask")}
              </ButtonConnect>
            </div>
          </>
        )}
      </ModalContainer>
    </Modal>
  );
};

export default ModalConnectWallet;
